<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电站信息</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <el-form ref="firstForm" :model="firstForm" :rules="rules" label-position="left" label-width="120px" style="width: 400px; margin-top: 20px;">
        <el-form-item label="设置名称" prop="setName">
          <el-input
            v-model="firstForm.setName"
            :disabled="disabled"
            placeholder="请输入设置名称"
          />
        </el-form-item>
        <el-form-item label="选择电站" prop="alarmItemsArray">
          <STree v-model="firstForm.alarmItemsArray" :data="datatree" :is-show-filter="false" style="width:400px;" />
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电桩充电告警</span>
      </div>
      <el-form ref="secondForm" :model="secondForm" label-position="left" label-width="120px" style="margin-top: 20px;">
        <el-form-item label="枪线温度过高">
          <el-form-item v-for="(item, index) in secondForm.a1" :key="index" :label="item.alarmLevel == '1' ? '一级告警阈值' : item.alarmLevel == '2' ? '二级告警阈值' : '三级告警阈值'">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      :disabled="disabled"
                      placeholder=""
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">℃</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
        <el-form-item label="枪线温度过低">
          <el-form-item v-for="(item, index) in secondForm.a2" :key="index" :label="item.alarmLevel == '1' ? '一级告警阈值' : item.alarmLevel == '2' ? '二级告警阈值' : '三级告警阈值'">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      :disabled="disabled"
                      placeholder=""
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">℃</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
        <el-form-item label="电压过高">
          <el-form-item v-for="(item, index) in secondForm.b1" :key="index" :label="item.alarmLevel == '1' ? '一级告警阈值' : item.alarmLevel == '2' ? '二级告警阈值' : '三级告警阈值'">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      placeholder=""
                      :disabled="disabled"
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">V</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
        <el-form-item label="电压过低">
          <el-form-item v-for="(item, index) in secondForm.b2" :key="index" :label="item.alarmLevel == '1' ? '一级告警阈值' : item.alarmLevel == '2' ? '二级告警阈值' : '三级告警阈值'">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      placeholder=""
                      :disabled="disabled"
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">V</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
        <el-form-item label="电流过高">
          <el-form-item v-for="(item, index) in secondForm.c1" :key="index" :label="item.alarmLevel == '1' ? '一级告警阈值' : item.alarmLevel == '2' ? '二级告警阈值' : '三级告警阈值'">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      placeholder=""
                      :disabled="disabled"
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">A</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
        <el-form-item label="电流过低">
          <el-form-item v-for="(item, index) in secondForm.c2" :key="index" :label="item.alarmLevel == '1' ? '一级告警阈值' : item.alarmLevel == '2' ? '二级告警阈值' : '三级告警阈值'">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      placeholder=""
                      :disabled="disabled"
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">A</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
        <el-form-item label="输入功率不足">
          <el-form-item v-for="(item, index) in secondForm.d1" :key="index" :label="item.alarmLevel == '1' ? '一级告警阈值' : item.alarmLevel == '2' ? '二级告警阈值' : '三级告警阈值'">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      placeholder=""
                      :disabled="disabled"
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">A</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电桩离线告警</span>
      </div>
      <el-form ref="thirdForm" :model="thirdForm" label-position="left" label-width="120px" style=" margin-top: 20px;">
        <el-form-item label="电桩离线告警">
          <el-form-item v-for="(item, index) in thirdForm.a1" :key="index" label="离线时长">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      placeholder=""
                      :disabled="disabled"
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">分钟</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">电桩故障告警</span>
      </div>
      <el-form ref="fourthForm" :model="fourthForm" label-position="left" label-width="120px" style=" margin-top: 20px;">
        <el-form-item label="电桩故障告警">
          <el-form-item v-for="(item, index) in fourthForm.a1" :key="index" label=" ">
            <div style="margin-left: 50%;">
              <el-checkbox v-model="item.isAlarm" label="是否告警" :disabled="disabled" />
              <el-checkbox v-model="item.isSendSMS" label="告警短信" :disabled="disabled" />
              <el-checkbox v-model="item.isStopCharging" label="自动停充" :disabled="disabled" />
            </div>
          </el-form-item>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">车辆告警</span>
      </div>
      <el-form ref="fiveForm" :model="fiveForm" label-position="left" label-width="120px" style=" margin-top: 20px;">
        <el-form-item label="电池电量监控">
          <el-form-item v-for="(item, index) in fiveForm.a1" :key="index" :label="item.alarmLevel == '1' ? '一级告警阈值' : item.alarmLevel == '2' ? '二级告警阈值' : '三级告警阈值'">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      placeholder=""
                      :disabled="disabled"
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">KWH</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
        <el-form-item label="SOC监控">
          <el-form-item v-for="(item, index) in fiveForm.b1" :key="index" :label="item.alarmLevel == '1' ? '一级告警阈值' : item.alarmLevel == '2' ? '二级告警阈值' : '三级告警阈值'">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      placeholder=""
                      :disabled="disabled"
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">%</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
        <el-form-item label="电池温度监控">
          <el-form-item v-for="(item, index) in fiveForm.c1" :key="index" :label="item.alarmLevel == '1' ? '一级告警阈值' : item.alarmLevel == '2' ? '二级告警阈值' : '三级告警阈值'">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      placeholder=""
                      :disabled="disabled"
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">℃</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">用户告警</span>
      </div>
      <el-form ref="lastForm" :model="lastForm" label-position="left" label-width="120px" style=" margin-top: 20px;">
        <el-form-item label="用户账号负值">
          <el-form-item v-for="(item, index) in lastForm.a1" :key="index" label="告警阈值">
            <el-row>
              <el-col :span="12">
                <el-row>
                  <el-col :span="12">
                    <el-input
                      v-model="item.threshold"
                      placeholder=""
                      :disabled="disabled"
                    />
                  </el-col>
                  <el-col :span="8">
                    <div style="margin-left: 10px">元</div>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-checkbox v-model="item.isAlarm" :disabled="disabled" label="是否告警" />
                <el-checkbox v-model="item.isSendSMS" :disabled="disabled" label="告警短信" />
                <el-checkbox v-model="item.isStopCharging" :disabled="disabled" label="自动停充" />
              </el-col>
            </el-row>
          </el-form-item>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
export default {
  name: 'Xiugaigaojingshezhi',
  components: {},
  data() {
    return {
      firstForm: {
        setName: '',
        alarmItemsArray: []
      },
      rules: {},
      datatree: [],
      secondForm: {
        a1: [
          {
            termName: '枪线温度过高', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '1', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_TEMPERATURE_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过高）
            isAlarm: false // 是否告警true、false
          },
          {
            termName: '枪线温度过高', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '2', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_TEMPERATURE_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过高）
            isAlarm: false // 是否告警
          },
          {
            termName: '枪线温度过高', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '3', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_TEMPERATURE_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过高）
            isAlarm: false // 是否告警
          }
        ],
        a2: [
          {
            termName: '枪线温度过低', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '1', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_TEMPERATURE_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '枪线温度过低', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '2', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_TEMPERATURE_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '枪线温度过低', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '3', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_TEMPERATURE_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          }
        ],
        b1: [
          {
            termName: '电压过高', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '1', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_VOLTAGE_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过高）
            isAlarm: false // 是否告警true、false
          },
          {
            termName: '电压过高', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '2', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_VOLTAGE_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过高）
            isAlarm: false // 是否告警
          },
          {
            termName: '电压过高', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '3', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_VOLTAGE_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过高）
            isAlarm: false // 是否告警
          }
        ],
        b2: [
          {
            termName: '电压过低', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '1', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_VOLTAGE_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '电压过低', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '2', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_VOLTAGE_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '电压过低', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '3', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_VOLTAGE_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          }
        ],
        c1: [
          {
            termName: '电流过高', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '1', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_ELECTRIC_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过高）
            isAlarm: false // 是否告警true、false
          },
          {
            termName: '电流过高', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '2', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_ELECTRIC_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过高）
            isAlarm: false // 是否告警
          },
          {
            termName: '电流过高', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '3', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_ELECTRIC_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过高）
            isAlarm: false // 是否告警
          }
        ],
        c2: [
          {
            termName: '电流过低', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '1', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_ELECTRIC_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '电流过低', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '2', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_ELECTRIC_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '电流过低', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '3', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_ELECTRIC_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          }
        ],
        d1: [
          {
            termName: '输入功率不足', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '1', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_ELECTRIC_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '输入功率不足', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '2', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_ELECTRIC_ALARM',	// 告警类型
            compareMode: 'COMPARE_LOW_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          }
        ]
      },
      thirdForm: {
        a1: [
          {
            termName: '电桩离线告警', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_OFFLINE_ALARM',	// 告警类型
            compareMode: '',	// 比较模式（过低）
            isAlarm: false // 是否告警
          }
        ]
      },

      fourthForm: {
        a1: [
          {
            termName: '电桩故障告警', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'EQUIPMENT_FAULT_ALARM',	// 告警类型
            compareMode: '',	// 比较模式（过低）
            isAlarm: false // 是否告警
          }
        ]
      },

      fiveForm: {
        a1: [
          {
            termName: '电池电量监控', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '1', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'VEHICLE_QUANTITY_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '电池电量监控', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '2', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'VEHICLE_QUANTITY_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '电池电量监控', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '3', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'VEHICLE_QUANTITY_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          }
        ],

        b1: [
          {
            termName: 'SOC监控', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '1', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'VEHICLE_SOC_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: 'SOC监控', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '2', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'VEHICLE_SOC_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: 'SOC监控', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '3', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'VEHICLE_SOC_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          }
        ],
        c1: [
          {
            termName: '电池温度监控', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '1', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'VEHICLE_TEMPERATURE_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '电池温度监控', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '2', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'VEHICLE_TEMPERATURE_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          },
          {
            termName: '电池温度监控', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '3', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'VEHICLE_TEMPERATURE_ALARM',	// 告警类型
            compareMode: 'COMPARE_HIGH_MODE',	// 比较模式（过低）
            isAlarm: false // 是否告警
          }
        ]
      },
      lastForm: {
        a1: [
          {
            termName: '用户账户负值', // 设置名称
            threshold: '',	// 阈值
            alarmLevel: '', // 告警等级1，2，3
            isSendSMS: true,	// 是否发送短信true、false
            isStopCharging: false,	// 是否自动停充true、false
            alarmType: 'USER_BALANCE_ALARM',	// 告警类型
            compareMode: '',	// 比较模式（过低）
            isAlarm: false // 是否告警
          }
        ]
      },
      defaultProps: {
        children: 'children',
        label: 'name',
        value: 'id'
      },
      disabled: true,
      id: ''
    }
  },
  computed: {
    headers() {
      return {
        token: window.localStorage.getItem('token')
      }
    },
    action() {
      return HOST + '/oss'
    }
  },
  mounted() {
    this.getTree()
    this.getDataDetail()
    const labelAry = document.getElementsByClassName('el-checkbox__label')
    for (let i = 0; i < labelAry.length; i++) {
      labelAry[i].style.color = '#333'
    }
  },
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.id = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {

    cancel() {
      this.$router.go(-1)
    },

    getTree() {
      this.$store.dispatch('form/handle', {
        url: '/alarm/alarmSet/connectorTree',
        method: 'get',
        callback: resp => {
          console.log('tree', resp)
          this.datatree = resp
        }
      })
    },

    getDataDetail() {
      const data = {
        id: this.id
      }
      this.$store.dispatch('form/handle', {
        url: '/alarm/alarmSet/getEditData',
        data: data,
        method: 'get',
        callback: resp => {
          console.log(resp)
          this.firstForm.setName = resp.setName
          this.firstForm.alarmItemsArray = resp.alarmItemsArray
          for (let i = 0; i < resp.alarmTerms.length; i++) {
            if (resp.alarmTerms[i].termName === '枪线温度过高' && resp.alarmTerms[i].alarmLevel === '1') {
              this.secondForm.a1[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '枪线温度过高' && resp.alarmTerms[i].alarmLevel === '2') {
              this.secondForm.a1[1] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '枪线温度过高' && resp.alarmTerms[i].alarmLevel === '3') {
              this.secondForm.a1[2] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '枪线温度过低' && resp.alarmTerms[i].alarmLevel === '1') {
              this.secondForm.a2[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '枪线温度过低' && resp.alarmTerms[i].alarmLevel === '2') {
              this.secondForm.a2[1] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '枪线温度过低' && resp.alarmTerms[i].alarmLevel === '3') {
              this.secondForm.a2[2] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电压过高' && resp.alarmTerms[i].alarmLevel === '1') {
              this.secondForm.b1[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电压过高' && resp.alarmTerms[i].alarmLevel === '2') {
              this.secondForm.b1[1] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电压过高' && resp.alarmTerms[i].alarmLevel === '3') {
              this.secondForm.b1[2] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电压过低' && resp.alarmTerms[i].alarmLevel === '1') {
              this.secondForm.b2[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电压过低' && resp.alarmTerms[i].alarmLevel === '2') {
              this.secondForm.b2[1] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电压过低' && resp.alarmTerms[i].alarmLevel === '3') {
              this.secondForm.b2[2] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电流过高' && resp.alarmTerms[i].alarmLevel === '1') {
              this.secondForm.c1[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电流过高' && resp.alarmTerms[i].alarmLevel === '2') {
              this.secondForm.c1[1] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电流过高' && resp.alarmTerms[i].alarmLevel === '3') {
              this.secondForm.c1[2] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电流过低' && resp.alarmTerms[i].alarmLevel === '1') {
              this.secondForm.c2[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电流过低' && resp.alarmTerms[i].alarmLevel === '2') {
              this.secondForm.c2[1] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电流过低' && resp.alarmTerms[i].alarmLevel === '3') {
              this.secondForm.c2[2] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '输入功率不足' && resp.alarmTerms[i].alarmLevel === '1') {
              this.secondForm.d1[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '输入功率不足' && resp.alarmTerms[i].alarmLevel === '2') {
              this.secondForm.d1[1] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电桩离线告警' && resp.alarmTerms[i].alarmLevel === '') {
              this.thirdForm.a1[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电桩故障告警' && resp.alarmTerms[i].alarmLevel === '') {
              this.fourthForm.a1[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电池电量监控' && resp.alarmTerms[i].alarmLevel === '1') {
              this.fiveForm.a1[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电池电量监控' && resp.alarmTerms[i].alarmLevel === '2') {
              this.fiveForm.a1[1] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电池电量监控' && resp.alarmTerms[i].alarmLevel === '3') {
              this.fiveForm.a1[2] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === 'SOC监控' && resp.alarmTerms[i].alarmLevel === '1') {
              this.fiveForm.b1[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === 'SOC监控' && resp.alarmTerms[i].alarmLevel === '2') {
              this.fiveForm.b1[1] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === 'SOC监控' && resp.alarmTerms[i].alarmLevel === '3') {
              this.fiveForm.b1[2] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电池温度监控' && resp.alarmTerms[i].alarmLevel === '1') {
              this.fiveForm.c1[0] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电池温度监控' && resp.alarmTerms[i].alarmLevel === '2') {
              this.fiveForm.c1[1] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '电池温度监控' && resp.alarmTerms[i].alarmLevel === '3') {
              this.fiveForm.c1[2] = resp.alarmTerms[i]
            } else if (resp.alarmTerms[i].termName === '用户账户负值' && resp.alarmTerms[i].alarmLevel === '') {
              this.lastForm.a1[0] = resp.alarmTerms[i]
            }
          }
        }
      })
    }

  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style lang="less" src="" scoped>
 .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }

  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-checkbox .el-checkbox__label{
    color: #333;
  }

</style>



// WEBPACK FOOTER //
// src/views/alarmManagement/alarmSettingDetail.vue